/**
 * This version is automatically updated by the Makefile
 * @public
 */
export const version = "1.3.6"
